module.exports = __webpack_public_path__ + "15_ldav.pdf?600e89787ffb51088d884a22bd9bd58d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_ldav.pdf
// module id = 141
// module chunks = 0